// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ot-0";